import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { GetPrinterJpkDocumentDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { parsePrinterBinaryData } from './parseBinaryData';

interface Props {
  show: boolean;
  onHide: () => void;
  document: GetPrinterJpkDocumentDto;
}

export const PrinterJpkDocumentPreviewModal: React.FC<Props> = ({
  show,
  onHide,
  document,
}) => {
  const html = document.binaryData
    ? parsePrinterBinaryData(document.binaryData)
    : null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          Podgląd dokumentu JPK #{document.jpkId ?? '—'} —{' '}
          {document.printerUid ?? '—'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {html ? (
          <div className="jpk-preview-scroll">
            <div
              dangerouslySetInnerHTML={{ __html: html }}
              className="jpk-preview-content"
            />
          </div>
        ) : (
          <pre
            className="text-muted"
            style={{ maxHeight: '400px', overflow: 'auto' }}
          >
            {JSON.stringify(document.jpkData, null, 2)}
          </pre>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
